import {get, toNumber} from "lodash";
import React, {useState} from "react";
import {ProductState} from "../../../interfaces/ProductComponentState";
import AppCartController from "../../../../Main/controller/AppCartController";
import {ReactComponent as PlusIcon} from "./assets/image/add.svg";
import {ReactComponent as MinusIcon} from "./assets/image/remove.svg";
import {AnimatePresence, motion} from "framer-motion";
import ProductController from "../../../controller/ProductController";
import AppSettingController from "../../../../Main/controller/AppSettingController";
import {useTranslation} from "react-i18next";

export default function BtnAddToCart({item}: { item: ProductState }) {
    const {t} = useTranslation();
    const isExistProductInCart = AppCartController.isExistInCart(item);
    const [state, setState] = useState(false)
    const out = toNumber(item.total) > 0 && item.status;

    if (!AppSettingController.isActiveCart())
        return null

    if (!isExistProductInCart)
        return (
            <motion.button
                className={`${out ? 'available' : 'not-available'}`}
                onClick={() => ProductController.addToCart(item, state, setState)}
                animate={{
                    opacity: out ? 1 : 0.5,
                    transition: {duration: 0.3},
                }}>
                {out ? t("add") : t("unavailable")}
            </motion.button>
        )

    return (
        <motion.div
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            exit={{height: 0, opacity: 0}}
            style={{overflow: "hidden"}}
            className={'quantity'}>
            <motion.button className="quantity-increase"
                           onClick={() => out ? ProductController.addToCart(item, state, setState) : null}>
                <PlusIcon/>
            </motion.button>
            <AnimatePresence mode="popLayout">
                <motion.p>
                    {get(isExistProductInCart, 'quantity')}
                </motion.p>
            </AnimatePresence>
            <motion.button className="decrease" onClick={() => ProductController.removeToCart(item, state, setState)}>
                <MinusIcon/>
            </motion.button>
        </motion.div>
    )
}